export default "__VITE_ASSET__jxVNOxAL__"